define(function (require) {
    var avalon = require('avalon'),
        ajax = require('ajax'),
        tool = require('toolLoaderPC');

    var hiddenValues, getPaykit;

    // 支付成功后需要轮休后台查询支付的状态
    var queryWechatStateKit,
        queryWechatStateTime = 3000,
        queryWechatStateInterval;

    var vmodel = avalon.define({
        $id: 'cooperCashController',
        payType: '1', // 支付类型 1 支付宝， 4 微信

        order: {},
        order_sku: [],

        isShowOrder: false,
        convertShowOrder: function () {
            vmodel.isShowOrder = !vmodel.isShowOrder;
        },

        weixinUrl: '',
        discount: false,

        typeClick: function (type) {
            if (type === '4' && !vmodel.weixinUrl) {
                // 如果是微信支付 且没有查询微信二维码 那就获取微信二维码
                vmodel.payClick(type);
            }
            vmodel.payType = type;

            if (queryWechatStateInterval) {
                clearTimeout(queryWechatStateInterval);
            }
            if (type === '4') {
                queryWechatStateInterval = setTimeout(
                    queryWechatState,
                    queryWechatStateTime
                );
            }
        },

        payClick: function (type) {
            tool.singleWay(
                'mall-order-list-pay-' + vmodel.order.order_id,
                function (key) {
                    getPaykit = this;
                    ajax
                        .getWithFail('../default/pay.html', {
                            order_id: vmodel.order.order_id,
                            channel_id: type
                        })
                        .done(function (response) {
                            getPaykit.resolve(key);

                            var msg = response.msg;
                            if (
                                msg.channel_id == 0 ||
                                msg.channel_id == 1 ||
                                !msg.money
                            ) {
                                // 金额为0直接支付 或 支付宝直接跳转
                                ajax.pjax(msg.url);
                            } else {
                                vmodel.weixinUrl = msg.url;
                            }
                        })
                        .fail(function () {
                            getPaykit.resolve(key);
                        });
                }
            );
        }
    });

    // 查询微信支付的状态
    function queryWechatState () {
        tool.singleWay(
            'query-reward-wechat-state-' + vmodel.order.order_id,
            function (key) {
                queryWechatStateKit = this;

                ajax
                    .get('../default/check-is-finished.html', {
                        order_id: vmodel.order.order_id
                    })
                    .done(function (resp) {
                        if (queryWechatStateInterval) {
                            clearTimeout(queryWechatStateInterval);
                        }

                        if (resp.type === 'succ') {
                            ajax.pjax('/order_list.html');
                        } else {
                            queryWechatStateInterval = setTimeout(
                                queryWechatState,
                                queryWechatStateTime
                            );
                        }

                        queryWechatStateKit.resolve(key);
                    })
                    .fail(function () {
                        if (queryWechatStateInterval) {
                            clearTimeout(queryWechatStateInterval);
                        }

                        queryWechatStateInterval = setTimeout(
                            queryWechatState,
                            queryWechatStateTime
                        );

                        queryWechatStateKit.resolve(key);
                    });
            }
        );
    }

    return {
        init: function () {
            hiddenValues = tool.getHiddenValues('#js-local-hiddens');
            vmodel.order = hiddenValues.order;
            vmodel.order_sku = hiddenValues.order_sku;
            vmodel.discount = hiddenValues.discount;

            console.log(hiddenValues);
        },
        clear: function () {}
    };
});



// WEBPACK FOOTER //
// ./src/js_modules/cooperCashController.js